<template>
    <Link :href="href"
        class="group block rounded-lg p-2.5 transition-colors duration-200 hover:bg-white/[0.05] focus:outline-none focus-visible:ring-2 focus-visible:ring-nomad-accent">
        <div class="relative w-full overflow-hidden bg-nomad-800"
            :class="[round ? 'rounded-full' : 'rounded-md', poster ? 'aspect-[3/4]' : 'aspect-square']">
            <img v-if="image" :src="image" :alt="title" loading="lazy" class="h-full w-full object-cover" />
            <span v-else class="icon-music absolute inset-0 flex items-center justify-center text-3xl text-nomad-500" aria-hidden="true"></span>
            <button v-if="play" type="button" @click.prevent.stop="onPlay" :aria-label="'Play ' + title"
                class="nl-play-fab absolute bottom-2 right-2 h-11 w-11 translate-y-1 text-base opacity-0 shadow-lift transition-all duration-200 group-hover:translate-y-0 group-hover:opacity-100 focus:translate-y-0 focus:opacity-100">
                <span class="icon-play translate-x-px" aria-hidden="true"></span>
            </button>
        </div>
        <div class="mt-2.5" :class="{ 'text-center': round }">
            <p class="truncate text-sm font-medium text-white">{{ title }}</p>
            <p v-if="subtitle" class="mt-0.5 line-clamp-2 text-[0.8125rem] text-nomad-400">{{ subtitle }}</p>
        </div>
    </Link>
</template>
<script>
import { Link } from "@inertiajs/vue3";
export default {
    name: "MediaCard",
    components: { Link },
    props: {
        href: { type: String, required: true },
        image: String,
        title: String,
        subtitle: String,
        round: Boolean,
        poster: Boolean,
        // Payload for current/prepareCurrent, e.g. { id, type: 'SONG', name }
        play: { type: Object, default: null },
    },
    methods: {
        onPlay() {
            this.$store.dispatch("current/prepareCurrent", this.play);
        },
    },
};
</script>
